import React, { useEffect, useState, ChangeEvent } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import useFetch from 'use-http';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import CreditCardType from 'src/models/AP/CreditCardType';
import DialogList from 'src/dialogs';
// import { FcOpenedFolder } from 'react-icons/fc';

interface ILoadRawDataFileDialogProps {
    dialogName: string;
    handleCategories?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    setFileToUpload: (formData: FormData) => void;
    creditCardTypes: CreditCardType[];
}

const LoadRawDataFileDialog = (props: ILoadRawDataFileDialogProps) => {
    const { register, errors } = useForm();
    const [selectedFile, setSelectedFile] = useState<FormData>(undefined);
    const { get, response } = useFetch();
    const [chargeIndividuals, setChargeIndividuals] = useState<{id: number, name: string}[]>([]);
    const [selectedChargeIndividual, setSelectedChargeIndividual] = useState<string>(undefined);
    const [selectedCreditCard, setSelectedCreditCard] = useState<string>(undefined);

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('LoadRawDataFileDialog onCreate()');
    };

    const onDestroy = () => {
        setSelectedFile(undefined);
        setChargeIndividuals([]);
        setSelectedChargeIndividual(undefined);
        setSelectedCreditCard(undefined);
    };

    const getAuthorizedCreditCardChargeIndividuals = async (ccId: string) => {
        setSelectedCreditCard(ccId);
        let result = await get(`/v1.0/AccountsPayable/creditcard/chargeIndividuals/${ccId}`);

        if (response.ok) {
            setChargeIndividuals(result);
        } else {
            console.log('Unable to get credit card receipt Data!');
        }
    };

    // const showDialog = (dialog: DialogList) => {
    //     dispatch(actions.layout.showDialog(dialog));
    // };

    // const hideDialog = () => {
    //     dispatch(actions.layout.hideDialog());
    // };

    // const reports = () => {
    //     showDialog(DialogList.VENDOR_REPORTS);
    // };

    const OKClicked = () => {
        if (!!selectedFile && !!selectedChargeIndividual && !!selectedCreditCard) {
            props.setFileToUpload(selectedFile);
            onDestroy();
            props.hideDialog();
        } else {
            if (!selectedCreditCard) {
                let ccIdBox = document.getElementById(`!creditCardTypes!`);
                ccIdBox.setAttribute('style', 'width: 100%; border: solid 2px red');
                return;
            } else {
                let ccIdBox = document.getElementById(`!creditCardTypes!`);
                ccIdBox.setAttribute('style', 'width: 100%');
            }
            if (!selectedChargeIndividual) {
                let ccIdBox = document.getElementById(`!chargeIndividuals!`);
                ccIdBox.setAttribute('style', 'width: 100%; border: solid 2px red');
                return;
            } else {
                let ccIdBox = document.getElementById(`!chargeIndividuals!`);
                ccIdBox.setAttribute('style', 'width: 100%');
            }
            if (!selectedFile) {
                let ccIdBox = document.getElementById(`!creditCardStatmentFile!`);
                ccIdBox.setAttribute('style', 'width: 100%; margin: 0px; border: solid 2px red');
                return;
            } else {
                let ccIdBox = document.getElementById(`!creditCardStatmentFile!`);
                ccIdBox.setAttribute('style', 'width: 100%; margin: 0px;');
            }
        }
    };

    const handleCsvFileSelected = (event: ChangeEvent<HTMLInputElement>) => {
        if (!selectedCreditCard) {
            let ccIdBox = document.getElementById(`!creditCardTypes!`);
            ccIdBox.setAttribute('style', 'width: 100%; border: solid 2px red');
            return;
        } else {
            let ccIdBox = document.getElementById(`!creditCardTypes!`);
            ccIdBox.setAttribute('style', 'width: 100%;');
        }
        if (!selectedChargeIndividual) {
            let ccIdBox = document.getElementById(`!chargeIndividuals!`);
            ccIdBox.setAttribute('style', 'width: 100%; border: solid 2px red');
            return;
        } else {
            let ccIdBox = document.getElementById(`!chargeIndividuals!`);
            ccIdBox.setAttribute('style', 'width: 100%;');
        }

        let sfBox = document.getElementById(`!creditCardStatmentFile!`);
        sfBox.setAttribute('style', 'width: 100%; margin: 0px;');
        const fileList = event.currentTarget.files;
        const formData = new FormData();
        formData.append('fileObject', fileList[0]);
        formData.append('fileName', fileList[0].name);
        formData.append('fileType', fileList[0].name.split('.').pop());
        formData.append('note', selectedCreditCard);
        formData.append('docType', selectedChargeIndividual);
        setSelectedFile(formData);
    };

    // const buttonClick = () => {
    //     console.log('Button Clicked');
    // };

    return (
        <Dialog title="Load Raw Data File" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        name={`creditCardNumber`}
                        label="Credit Card No"
                        id={`!creditCardTypes!`}
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={props?.creditCardTypes?.map(c => {
                            return { value: c.id, label: c.name };
                            })}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem' }}
                        onChange={(ev) => getAuthorizedCreditCardChargeIndividuals(ev.currentTarget.value)}
                    />
                    <RHFInputBox
                        id={`!creditCardStatmentFile!`}
                        label="Filename"
                        labelOnLeft={true}
                        labelStyle={{ width: '17rem', margin: '0'}}
                        name={`excelFile.filename`}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCsvFileSelected(e)}
                        type="file"
                        register={register}
                        errors={errors}
                        style={{ width: '100%', margin: '0' }}
                        bodyStyle={{ width: '40rem' }}
                    />
                    <RHFSelect
                        id={`!chargeIndividuals!`}
                        name={`ChargedBy`}
                        label="Charged By"
                        labelOnLeft={true}
                        labelStyle={{ width: '20rem', margin: '0'}}
                        options={chargeIndividuals?.map(c => {
                            return { value: c.id, label: c.name };
                            })}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30rem', marginTop: '1rem' }}
                        onChange={(ev) => setSelectedChargeIndividual(ev.currentTarget.value)}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
                </Dialog>
    );
};

export default LoadRawDataFileDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/LoadRawDataFileDialog.tsx